exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".style_internalLink__WVl2K{color:#2f93e0;text-decoration:none}.style_internalLink__WVl2K:hover{color:#0a67b1}.style_listInternalLink__3Z097,.style_listInternalLink__3Z097:focus,.style_listInternalLink__3Z097:hover{color:inherit}", ""]);

// exports
exports.locals = {
	"internalLink": "style_internalLink__WVl2K",
	"listInternalLink": "style_listInternalLink__3Z097"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/Navigation/InternalLink/style.less
// module id = 1422
// module chunks = 8